import { useCallback } from 'react'

import { Button, Flex, Text, VStack } from '@chakra-ui/react'
import { useEditorLinks } from '@editor/EditorProvider'
import { AddIcon } from '@editor/chakra-ui-icons'
import { RootState } from '@editor/store/app'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'

import useCreateBlueprint from '../tools/BlueprintManager/hooks/useCreateBlueprint'

const NoBlueprints = () => {
  const isAllowedToModify = useSelector((state: RootState) => state.blueprint.editor.isAllowedToModify)
  const isOwner = useSelector((state: RootState) => state.page.isOwner)
  const { planManagementUrl } = useEditorLinks()
  const navigate = useNavigate()

  const { handleStartCreatingBlueprint } = useCreateBlueprint()

  // Only owners can manage the plan, so invited users get no Markly activation prompt.
  // let message = 'There are no blueprints available.'
  let message = '利用可能な設計図面はありません。'
  if (isAllowedToModify) {
    // message = 'Create a new blueprint to get started.'
    message = '始めるには新しい設計図面を作成してください。'
  } else if (isOwner) {
    // message = 'There are no blueprints available. You need to activate Markly to create one.'
    message = '利用可能な設計図面はありません。作成にはMarklyを有効化する必要があります。'
  }

  // The host must also have somewhere to send them; see `planManagementUrl`.
  const showPlanManagement = !isAllowedToModify && isOwner && !!planManagementUrl

  /**
   * Send the user to plan management. The host decides where that is: an absolute
   * URL belongs to another app and leaves this one, a path is an in-app route.
   */
  const handleManagePlan = useCallback(() => {
    if (!planManagementUrl) return

    if (/^https?:\/\//.test(planManagementUrl)) {
      window.location.href = planManagementUrl
      return
    }

    void navigate(planManagementUrl)
  }, [planManagementUrl, navigate])

  return (
    <VStack p={0} m={0} w="100vw" h="100vh" position="absolute" top={0} left={0} zIndex={100} gap={0}>
      <Flex
        bg="black"
        flex={1}
        w="100%"
        color="white"
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
        gap={3}
      >
        <Text fontSize="lg" color="gray2.300" textAlign="center">
          {message}
        </Text>
        {(isAllowedToModify || showPlanManagement) && (
          <Button
            variant="outline"
            color="gray2.100"
            borderColor="gray2.300"
            _hover={{ color: 'gray2.800', backgroundColor: 'white' }}
            size="lg"
            onClick={isAllowedToModify ? handleStartCreatingBlueprint : handleManagePlan}
          >
            {isAllowedToModify ? (
              <>
                <AddIcon />
                {/* Add blueprint */}
                設計図面を作成
              </>
            ) : (
              /* Go to plan management */
              'プラン管理へ'
            )}
          </Button>
        )}
      </Flex>
    </VStack>
  )
}

export default NoBlueprints
